import axios from "../../../../../axios";
import Cookies from "js-cookie";

//Get All BGV  Candidate
export const GetAllBGVCandidate = async () => {
  const token = Cookies.get("employeeToken");

  return axios.post("/api/Candidate/GetBGVCandidates", {
    token,
  });
};
